<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.oci"
        ref="DataTable"
        sort-by="nome"
    >
        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                @click="edit(item.id)"
                authorize="update-cadastro-oci"
                color="primary"
                small
                title="Editar"
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                :disabled="!!item.hasVinculos"
                @click="destroy(item.id)"
                authorize="destroy-cadastro-oci"
                color="danger"
                small
                title="Excluir"
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import { error, repository } from '@/mixins'

export default {
    created() {

        this.repositories = {
            oci: this.getConectaSusRepository('cadastro.oci')
        }
    },
    data: () => ({
        fields: [
            { key: 'nome', name: 'oci.nome', label: 'Nome', searchable: true, sortable: true },
            { key: 'procedimentoDescricao', name: 'procedimentoDescricao', label: 'Procedimento principal', searchable: true, sortable: true },
            { key: 'linhaCuidado', name: 'oci.linhaCuidado', label: 'Linha de cuidado', searchable: true, sortable: true },
            { key: 'codigo', name: 'oci.codigo', label: 'Código', searchable: true, sortable: true },
            { key: 'actions', label: 'Ações', class: 'col-min text-center' },
        ],
    }),
    methods: {
        edit(id) {

            this.$router.push({ name: 'cadastro-oci-edit', params: { id } })
        },
        destroy(id) {

            const destroy = () => this.repositories.oci.destroy(id)
                .then(() => this.$refs.DataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir a OCI?', destroy, this.handleError)
        },
    },
    mixins: [error, repository],
}
</script>